import type { Ecommerce } from '@features/ecommerce/types/ecommerce.types';

export const mockEcommerceData: Ecommerce[] = [
  {
    id: 'ecom_1',
    name: 'Main Store Checkout',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Primary checkout flow for main store',
    revenue30d: 125000,
    success: 98.5,
    transactions30d: 4200,
    volume30d: 125000,
    successRate: 0.985,
    lastUsed: '2024-01-15T10:30:00Z',
    created: '2023-06-15T09:00:00Z',
    lastUpdated: '2024-01-15T10:30:00Z'
  },
  {
    id: 'ecom_2',
    name: 'Mobile App API',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'API integration for mobile application',
    revenue30d: 67500,
    success: 97.2,
    transactions30d: 2800,
    volume30d: 67500,
    successRate: 0.972,
    lastUsed: '2024-01-14T16:45:00Z',
    created: '2023-08-20T14:30:00Z',
    lastUpdated: '2024-01-14T16:45:00Z'
  },
  {
    id: 'ecom_3',
    name: 'Test Environment',
    status: 'active',
    type: 'elements',
    environment: 'sandbox',
    description: 'Testing configuration for new features',
    revenue30d: 2250,
    success: 95.6,
    transactions30d: 150,
    volume30d: 2250,
    successRate: 0.956,
    lastUsed: '2024-01-12T11:20:00Z',
    created: '2024-01-01T10:00:00Z',
    lastUpdated: '2024-01-12T11:20:00Z'
  },
  {
    id: 'ecom_4',
    name: 'Legacy Drops',
    status: 'inactive',
    type: 'drops',
    environment: 'production',
    description: 'Legacy drop-in payment solution',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-12-20T08:15:00Z',
    created: '2023-03-10T12:00:00Z',
    lastUpdated: '2023-12-20T08:15:00Z'
  },
  {
    id: 'ecom_5',
    name: 'Subscription Portal',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Recurring payment checkout for subscriptions',
    revenue30d: 48000,
    success: 99.1,
    transactions30d: 1600,
    volume30d: 48000,
    successRate: 0.991,
    lastUsed: '2024-01-15T09:15:00Z',
    created: '2023-09-05T11:30:00Z',
    lastUpdated: '2024-01-15T09:15:00Z'
  },
  {
    id: 'ecom_6',
    name: 'B2B Wholesale Portal',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Enterprise wholesale payment integration',
    revenue30d: 89400,
    success: 97.8,
    transactions30d: 320,
    volume30d: 89400,
    successRate: 0.978,
    lastUsed: '2024-01-15T14:22:00Z',
    created: '2023-04-12T08:00:00Z',
    lastUpdated: '2024-01-15T14:22:00Z'
  },
  {
    id: 'ecom_7',
    name: 'International Checkout',
    status: 'blocked',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Blocked due to suspicious activity patterns',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-10T03:45:00Z',
    created: '2023-11-18T16:30:00Z',
    lastUpdated: '2024-01-10T03:45:00Z'
  },
  {
    id: 'ecom_8',
    name: 'Quick Pay Elements',
    status: 'active',
    type: 'elements',
    environment: 'production',
    description: 'Fast checkout using payment elements',
    revenue30d: 34200,
    success: 96.4,
    transactions30d: 1140,
    volume30d: 34200,
    successRate: 0.964,
    lastUsed: '2024-01-15T11:08:00Z',
    created: '2023-07-22T10:15:00Z',
    lastUpdated: '2024-01-15T11:08:00Z'
  },
  {
    id: 'ecom_9',
    name: 'Development Sandbox',
    status: 'inactive',
    type: 'api',
    environment: 'sandbox',
    description: 'Inactive development environment',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-12-05T09:30:00Z',
    created: '2023-05-08T13:45:00Z',
    lastUpdated: '2023-12-05T09:30:00Z'
  },
  {
    id: 'ecom_10',
    name: 'Event Tickets Portal',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Specialized checkout for event ticket sales',
    revenue30d: 156000,
    success: 98.9,
    transactions30d: 5200,
    volume30d: 156000,
    successRate: 0.989,
    lastUsed: '2024-01-15T18:42:00Z',
    created: '2023-02-14T11:00:00Z',
    lastUpdated: '2024-01-15T18:42:00Z'
  },
  {
    id: 'ecom_11',
    name: 'Fraud Investigation API',
    status: 'blocked',
    type: 'api',
    environment: 'production',
    description: 'Temporarily blocked pending fraud investigation',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-08T21:15:00Z',
    created: '2023-10-30T14:20:00Z',
    lastUpdated: '2024-01-08T21:15:00Z'
  },
  {
    id: 'ecom_12',
    name: 'Marketplace Integration',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Third-party marketplace payment processing',
    revenue30d: 72800,
    success: 95.2,
    transactions30d: 2600,
    volume30d: 72800,
    successRate: 0.952,
    lastUsed: '2024-01-15T16:33:00Z',
    created: '2023-06-01T09:30:00Z',
    lastUpdated: '2024-01-15T16:33:00Z'
  },
  {
    id: 'ecom_13',
    name: 'Beta Feature Test',
    status: 'inactive',
    type: 'elements',
    environment: 'sandbox',
    description: 'Discontinued beta feature testing',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-11-28T14:22:00Z',
    created: '2023-08-15T16:00:00Z',
    lastUpdated: '2023-11-28T14:22:00Z'
  },
  {
    id: 'ecom_14',
    name: 'Express Checkout v2',
    status: 'active',
    type: 'elements',
    environment: 'production',
    description: 'Enhanced express checkout experience',
    revenue30d: 98700,
    success: 99.3,
    transactions30d: 3290,
    volume30d: 98700,
    successRate: 0.993,
    lastUsed: '2024-01-15T19:15:00Z',
    created: '2023-12-01T10:00:00Z',
    lastUpdated: '2024-01-15T19:15:00Z'
  },
  {
    id: 'ecom_15',
    name: 'High Risk Processor',
    status: 'blocked',
    type: 'api',
    environment: 'production',
    description: 'Blocked due to repeated chargeback violations',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-05T12:30:00Z',
    created: '2023-09-12T15:45:00Z',
    lastUpdated: '2024-01-05T12:30:00Z'
  },
  {
    id: 'ecom_16',
    name: 'Social Commerce API',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Social media platform payment integration',
    revenue30d: 43500,
    success: 94.7,
    transactions30d: 1450,
    volume30d: 43500,
    successRate: 0.947,
    lastUsed: '2024-01-15T13:28:00Z',
    created: '2023-08-08T12:15:00Z',
    lastUpdated: '2024-01-15T13:28:00Z'
  },
  {
    id: 'ecom_17',
    name: 'Legacy Payment Form',
    status: 'inactive',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Deprecated payment form - use v2 instead',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-12-15T10:45:00Z',
    created: '2022-11-20T14:30:00Z',
    lastUpdated: '2023-12-15T10:45:00Z'
  },
  {
    id: 'ecom_18',
    name: 'Crypto Payment Gateway',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Cryptocurrency payment processing',
    revenue30d: 28900,
    success: 92.1,
    transactions30d: 890,
    volume30d: 28900,
    successRate: 0.921,
    lastUsed: '2024-01-15T17:52:00Z',
    created: '2023-04-25T11:20:00Z',
    lastUpdated: '2024-01-15T17:52:00Z'
  },
  {
    id: 'ecom_19',
    name: 'Partner Store Checkout',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'White-label checkout for partner stores',
    revenue30d: 61200,
    success: 97.5,
    transactions30d: 2040,
    volume30d: 61200,
    successRate: 0.975,
    lastUsed: '2024-01-15T15:18:00Z',
    created: '2023-03-28T09:45:00Z',
    lastUpdated: '2024-01-15T15:18:00Z'
  },
  {
    id: 'ecom_20',
    name: 'Compliance Violation Store',
    status: 'blocked',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Blocked for PCI compliance violations',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-03T08:22:00Z',
    created: '2023-07-14T13:00:00Z',
    lastUpdated: '2024-01-03T08:22:00Z'
  },
  {
    id: 'ecom_21',
    name: 'QA Testing Environment',
    status: 'inactive',
    type: 'elements',
    environment: 'sandbox',
    description: 'Quality assurance testing - currently unused',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-12-22T16:30:00Z',
    created: '2023-05-18T10:15:00Z',
    lastUpdated: '2023-12-22T16:30:00Z'
  },
  {
    id: 'ecom_22',
    name: 'Premium Membership Portal',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Exclusive checkout for premium memberships',
    revenue30d: 112000,
    success: 99.7,
    transactions30d: 1400,
    volume30d: 112000,
    successRate: 0.997,
    lastUsed: '2024-01-15T20:05:00Z',
    created: '2023-01-10T11:30:00Z',
    lastUpdated: '2024-01-15T20:05:00Z'
  },
  {
    id: 'ecom_23',
    name: 'Mobile Wallet Integration',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Apple Pay, Google Pay, and Samsung Pay integration',
    revenue30d: 84300,
    success: 98.2,
    transactions30d: 2810,
    volume30d: 84300,
    successRate: 0.982,
    lastUsed: '2024-01-15T18:47:00Z',
    created: '2023-09-22T14:45:00Z',
    lastUpdated: '2024-01-15T18:47:00Z'
  },
  {
    id: 'ecom_24',
    name: 'Abandoned Development API',
    status: 'inactive',
    type: 'api',
    environment: 'sandbox',
    description: 'Abandoned development project - no longer maintained',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-10-12T11:20:00Z',
    created: '2023-06-30T15:30:00Z',
    lastUpdated: '2023-10-12T11:20:00Z'
  },
  {
    id: 'ecom_25',
    name: 'Security Breach Investigation',
    status: 'blocked',
    type: 'elements',
    environment: 'production',
    description: 'Blocked pending security breach investigation',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-02T19:45:00Z',
    created: '2023-11-05T12:00:00Z',
    lastUpdated: '2024-01-02T19:45:00Z'
  },
  {
    id: 'ecom_26',
    name: 'Multi-Currency Checkout',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Supports EUR, GBP, CHF, SEK, and NOK payments',
    revenue30d: 234500,
    success: 97.1,
    transactions30d: 6800,
    volume30d: 234500,
    successRate: 0.971,
    lastUsed: '2024-01-15T22:10:00Z',
    created: '2023-05-20T10:00:00Z',
    lastUpdated: '2024-01-15T22:10:00Z'
  },
  {
    id: 'ecom_27',
    name: 'White-Label Checkout',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Fully branded checkout for partner merchants',
    revenue30d: 178900,
    success: 98.7,
    transactions30d: 5100,
    volume30d: 178900,
    successRate: 0.987,
    lastUsed: '2024-01-15T20:45:00Z',
    created: '2023-04-01T09:00:00Z',
    lastUpdated: '2024-01-15T20:45:00Z'
  },
  {
    id: 'ecom_28',
    name: 'POS Terminal Integration',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'In-store point-of-sale API integration',
    revenue30d: 456000,
    success: 99.2,
    transactions30d: 15200,
    volume30d: 456000,
    successRate: 0.992,
    lastUsed: '2024-01-15T23:59:00Z',
    created: '2023-01-15T08:30:00Z',
    lastUpdated: '2024-01-15T23:59:00Z'
  },
  {
    id: 'ecom_29',
    name: 'Recurring Billing Engine',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Automated recurring payment processing for SaaS platforms',
    revenue30d: 312000,
    success: 96.8,
    transactions30d: 10400,
    volume30d: 312000,
    successRate: 0.968,
    lastUsed: '2024-01-15T21:30:00Z',
    created: '2023-03-22T14:00:00Z',
    lastUpdated: '2024-01-15T21:30:00Z'
  },
  {
    id: 'ecom_30',
    name: 'Staging Environment v2',
    status: 'active',
    type: 'elements',
    environment: 'sandbox',
    description: 'New staging environment for v2 checkout redesign',
    revenue30d: 1500,
    success: 93.2,
    transactions30d: 85,
    volume30d: 1500,
    successRate: 0.932,
    lastUsed: '2024-01-15T17:00:00Z',
    created: '2024-01-10T11:00:00Z',
    lastUpdated: '2024-01-15T17:00:00Z'
  },
  {
    id: 'ecom_31',
    name: 'Klarna Pay Later',
    status: 'active',
    type: 'elements',
    environment: 'production',
    description: 'Buy now pay later integration via Klarna',
    revenue30d: 189700,
    success: 94.5,
    transactions30d: 4200,
    volume30d: 189700,
    successRate: 0.945,
    lastUsed: '2024-01-15T19:22:00Z',
    created: '2023-10-01T10:30:00Z',
    lastUpdated: '2024-01-15T19:22:00Z'
  },
  {
    id: 'ecom_32',
    name: 'Invoice Payment Portal',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'B2B invoice payment collection portal',
    revenue30d: 567000,
    success: 98.3,
    transactions30d: 890,
    volume30d: 567000,
    successRate: 0.983,
    lastUsed: '2024-01-15T16:00:00Z',
    created: '2023-07-10T12:00:00Z',
    lastUpdated: '2024-01-15T16:00:00Z'
  },
  {
    id: 'ecom_33',
    name: 'Deprecated Plugin v1',
    status: 'inactive',
    type: 'drops',
    environment: 'production',
    description: 'Legacy WordPress plugin - migrated to v2',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-11-01T10:00:00Z',
    created: '2022-06-15T09:00:00Z',
    lastUpdated: '2023-11-01T10:00:00Z'
  },
  {
    id: 'ecom_34',
    name: 'Marketplace Split Payments',
    status: 'active',
    type: 'api',
    environment: 'production',
    description: 'Multi-vendor marketplace with automatic payment splitting',
    revenue30d: 245800,
    success: 95.9,
    transactions30d: 7300,
    volume30d: 245800,
    successRate: 0.959,
    lastUsed: '2024-01-15T18:15:00Z',
    created: '2023-08-28T15:00:00Z',
    lastUpdated: '2024-01-15T18:15:00Z'
  },
  {
    id: 'ecom_35',
    name: 'Link-Based Checkout',
    status: 'active',
    type: 'link',
    environment: 'production',
    description: 'Shareable payment links for quick transactions',
    revenue30d: 87600,
    success: 91.8,
    transactions30d: 2920,
    volume30d: 87600,
    successRate: 0.918,
    lastUsed: '2024-01-15T14:50:00Z',
    created: '2023-09-15T11:30:00Z',
    lastUpdated: '2024-01-15T14:50:00Z'
  },
  {
    id: 'ecom_36',
    name: 'Compliance Blocked Store',
    status: 'blocked',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Blocked for KYC documentation discrepancies',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-07T11:30:00Z',
    created: '2023-06-20T13:00:00Z',
    lastUpdated: '2024-01-07T11:30:00Z'
  },
  {
    id: 'ecom_37',
    name: 'Donation Checkout Page',
    status: 'active',
    type: 'hosted_checkout',
    environment: 'production',
    description: 'Nonprofit donation collection with custom branding',
    revenue30d: 42300,
    success: 87.6,
    transactions30d: 1410,
    volume30d: 42300,
    successRate: 0.876,
    lastUsed: '2024-01-15T12:30:00Z',
    created: '2023-12-10T10:00:00Z',
    lastUpdated: '2024-01-15T12:30:00Z'
  },
  {
    id: 'ecom_38',
    name: 'Load Testing Sandbox',
    status: 'inactive',
    type: 'api',
    environment: 'sandbox',
    description: 'Used for performance testing - currently paused',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2023-12-28T16:00:00Z',
    created: '2023-10-15T14:00:00Z',
    lastUpdated: '2023-12-28T16:00:00Z'
  },
  {
    id: 'ecom_39',
    name: 'Embedded Payments SDK',
    status: 'active',
    type: 'elements',
    environment: 'production',
    description: 'Native SDK for mobile and web payment embedding',
    revenue30d: 398000,
    success: 97.9,
    transactions30d: 13267,
    volume30d: 398000,
    successRate: 0.979,
    lastUsed: '2024-01-15T23:45:00Z',
    created: '2023-02-01T08:00:00Z',
    lastUpdated: '2024-01-15T23:45:00Z'
  },
  {
    id: 'ecom_40',
    name: 'Suspicious Activity Gateway',
    status: 'blocked',
    type: 'api',
    environment: 'production',
    description: 'Blocked due to velocity rule violations',
    revenue30d: 0,
    success: 0,
    transactions30d: 0,
    volume30d: 0,
    successRate: 0,
    lastUsed: '2024-01-04T05:30:00Z',
    created: '2023-08-10T10:00:00Z',
    lastUpdated: '2024-01-04T05:30:00Z'
  }
];
